// Side-effect module to seed admin users in development when Supabase env is missing.
import { hasSupabaseEnv } from '../lib/supabaseClient';
import { devEnsureUser, addAdminWhitelist } from './devAuth';

(function seedAdmins(){
  try {
    if (hasSupabaseEnv) return; // Only in local dev fallback mode
    const admins = ['edwinpinto103@hotmail.com','edwinpinto103author@gmail.com'];
    const pwd = 'Admin';
    admins.forEach(email => devEnsureUser(email, pwd));
    addAdminWhitelist(admins);
  } catch (e) {
    // silent
  }
})();
